module.exports = __webpack_public_path__ + "static/img/G45.bb78c9b4.png";